export const translations = {
  en: {
    common: {
      home: 'Home',
      dailyDeals: 'Daily Deals',
      clientSuccess: 'Client Success',
      trackRecord: 'Track Record',
      getStarted: 'Get Started',
      privacyPolicy: 'Privacy Policy',
      termsOfService: 'Terms of Service',
      contact: 'Contact',
      allRightsReserved: 'All rights reserved',
      companyName: 'Rapida Inversion',
      liveData: 'Live data - Updates every 30 seconds',
      updatedDaily: 'Updated daily',
      filters: 'Filters',
      reset: 'Reset',
      category: 'Category',
      status: 'Status',
      strategy: 'Strategy',
      sortBy: 'Sort By',
      showMore: 'Show More',
      showLess: 'Show Less',
      fullDetails: 'Full Details',
      viewDetails: 'View Details',
      investment: 'Investment',
      keyHighlights: 'Key Highlights',
      showing: 'Showing',
      of: 'of',
      deals: 'deals',
      received: 'Received',
      invest: 'Invest',
      pending: 'Pending',
    },
    home: {
      title: 'Live Performance Dashboard',
      subtitle: 'Real-time tracking of all active investments and performance metrics',
      description: 'Monitor your investments in real-time with comprehensive analytics, live performance data, and transparent tracking across all portfolios. Every metric is updated continuously to provide you with the most accurate view of your investment performance.',
      heroTitle: 'Rapida Inversion',
      heroSubtitle: 'Real-time tracking of all active investments and performance metrics',
      heroDescription: 'Ready to increase your income potential? At Rapido Inversion, we provide secure and reliable investment opportunities built for fast results. Invest today and start seeing progress sooner than you think',
      getStartedButton: 'Get Started',
      getStartedSubtext: 'Invest now and see results in minutes',
    },
    dashboard: {
      totalPortfolioValue: 'Total Portfolio Value',
      activeInvestments: 'Active Investments',
      averageROI: 'Average ROI',
      monthlyReturns: 'Monthly Returns',
      todaysEarnings: "Today\'s Earnings",
      activeDeals: 'Active Deals',
      pendingReturns: 'Pending Returns',
      successRate: 'Success Rate',
      allCategories: 'All Categories',
      technology: 'Technology',
      realEstate: 'Real Estate',
      healthcare: 'Healthcare',
      energy: 'Energy',
      agriculture: 'Agriculture',
      allStatus: 'All Status',
      active: 'Active',
      monitoring: 'Monitoring',
      closingSoon: 'Closing Soon',
      allStrategies: 'All Strategies',
      growth: 'Growth',
      value: 'Value',
      income: 'Income',
      balanced: 'Balanced',
      highestProgress: 'Highest Progress',
      lowestProgress: 'Lowest Progress',
      highestValue: 'Highest Value',
      mostRecent: 'Most Recent',
    },
    dailyDeals: {
      title: 'Daily Deals Completed',
      subtitle: 'Transparent showcase of our successful investment transactions',
      description: 'Every deal tells a story of strategic insight, careful execution, and measurable results. Browse our comprehensive archive of completed investments with verified performance data, detailed timelines, and real client outcomes across diverse asset classes and strategies.',
      recentDeals: 'Recent Completed Deals',
      totalDealsCompleted: 'Total Deals Completed',
      totalInvestmentValue: 'Total Investment Value',
      averageROI: 'Average ROI',
      activeClients: 'Active Clients',
      completed: 'Completed',
      verified: 'Verified',
      settled: 'Settled',
      finance: 'Finance',
      allTime: 'All Time',
      today: 'Today',
      thisWeek: 'This Week',
      thisMonth: 'This Month',
      thisQuarter: 'This Quarter',
      highestROI: 'Highest ROI',
      lowestROI: 'Lowest ROI',
      highestAmount: 'Highest Amount',
      lowestAmount: 'Lowest Amount',
      dateRange: 'Date Range',
    },
    clientSuccess: {
      title: 'Client Success Gallery',
      subtitle: 'Verified client testimonials with actual performance data',
      description: 'See real success stories from professionals, family offices, and entrepreneurs who have achieved their financial goals with Inversión Rápida.',
      roi: 'ROI',
      timeframe: 'Timeframe',
      portfolioGrowth: 'Portfolio Growth',
    },
    trackRecord: {
      title: 'Rapida Team',
      subtitle: 'Connect with our team instantly. Get answers to your investment questions and discover how we can help you achieve your financial goals.',
      welcomeTitle: 'Welcome to Rapida Team',
      welcomeDescription1: 'Our dedicated team of investment professionals is here to provide you with rapid, reliable, and personalized investment solutions. We combine cutting-edge technology with human expertise to deliver exceptional results for our clients.',
      welcomeDescription2: 'Use our interactive chat assistant below to get instant answers about our services, investment strategies, and how we can help you achieve your financial objectives.',
      supportAvailable: 'Support Available',
      responseTime: 'Response Time',
      teamMembers: 'Team Members',
      reportProblem: 'Report Problem',
      chatTitle: 'Chat with Rapida Team',
      chatDescription: 'Our intelligent assistant is ready to answer your questions about investments, strategies, and how to get started with Inversión Rápida.',
      quickTips: 'Quick Tips',
      tip1: 'Ask about our investment strategies',
      tip2: 'Learn about our team and expertise',
      tip3: 'Get information on how to get started',
      tip4: 'Inquire about contact options',
      instant: 'Instant',
      expert: 'Expert',
      proven: 'Proven',
    },
    getStarted: {
      title: 'Get Started',
      subtitle: 'Schedule a personalized consultation with our investment experts',
      description: 'Choose your consultation type, investment level, and preferred time to begin your journey with Inversión Rápida.',
      type: 'Type',
      level: 'Level',
      details: 'Details',
      schedule: 'Schedule',
      review: 'Review',
      initialConsultation: 'Initial Consultation',
      initialConsultationDesc: 'Perfect for new investors exploring our services and investment strategies',
      portfolioReview: 'Portfolio Review',
      portfolioReviewDesc: 'Comprehensive analysis of your current investments and optimization opportunities',
      strategySession: 'Strategy Session',
      strategySessionDesc: 'Deep dive into specific investment strategies tailored to your goals',
      partnershipDiscussion: 'Partnership Discussion',
      partnershipDiscussionDesc: 'For financial advisors and institutions seeking co-investment opportunities',
      minutes: 'minutes',
      emergingInvestor: 'Emerging Investor',
      establishedInvestor: 'Established Investor',
      premiumInvestor: 'Premium Investor',
      elitePartnership: 'Elite Partnership',
      transparentPerformance: 'Transparent Performance',
      transparentPerformanceDesc: 'Real-time access to your portfolio performance and daily deal flow updates',
      expertTeam: 'Expert Team',
      expertTeamDesc: 'Dedicated investment professionals with proven track records',
      secureCompliant: 'Secure & Compliant',
      secureCompliantDesc: 'Bank-level security and full regulatory compliance',
    },
  },
  es: {
    common: {
      home: 'Inicio',
      dailyDeals: 'Ofertas Diarias',
      clientSuccess: 'Éxito de Clientes',
      trackRecord: 'Historial',
      getStarted: 'Comenzar',
      privacyPolicy: 'Política de Privacidad',
      termsOfService: 'Términos de Servicio',
      contact: 'Contacto',
      allRightsReserved: 'Todos los derechos reservados',
      companyName: 'Inversión Rápida',
      liveData: 'Datos en vivo - Se actualiza cada 30 segundos',
      updatedDaily: 'Actualizado diariamente',
      filters: 'Filtros',
      reset: 'Restablecer',
      category: 'Categoría',
      status: 'Estado',
      strategy: 'Estrategia',
      sortBy: 'Ordenar Por',
      showMore: 'Mostrar Más',
      showLess: 'Mostrar Menos',
      fullDetails: 'Detalles Completos',
      viewDetails: 'Ver Detalles',
      investment: 'Inversión',
      keyHighlights: 'Aspectos Destacados',
      showing: 'Mostrando',
      of: 'de',
      deals: 'ofertas',
      close: 'Cerrar',
      send: 'Enviar',
      loading: 'Cargando',
      error: 'Error',
      success: 'Éxito',
      received: 'Recibido',
      invest: 'Invertir',
      pending: 'Pendiente',
    },
    chatbot: {
      greeting: '¡Hola! Soy el asistente de IA del Equipo Rapida. Puedo responder sus preguntas sobre inversiones y ayudar a calificar sus necesidades de inversión. ¿Cómo puedo ayudarlo hoy?',
      placeholder: 'Pregunte sobre inversiones, estrategias o sus objetivos...',
      errorProcessing: 'Disculpe, pero tengo problemas para procesar su solicitud. Por favor, inténtelo de nuevo o contacte directamente a nuestro equipo.',
      errorConnection: 'Estoy experimentando problemas de conexión. Por favor, inténtelo de nuevo en un momento.',
      poweredBy: 'Impulsado por OpenAI • Listo para ayudar',
      systemPrompt: `Eres un asistente de IA para el Equipo Rapida, una firma de inversión profesional especializada en soluciones de inversión rápidas. Tu función es:\n\n1. Responder preguntas de inversores sobre estrategias de inversión, rendimiento y servicios\n2. Calificar prospectos comprendiendo sus objetivos de inversión, tolerancia al riesgo y disponibilidad de capital\n3. Proporcionar información útil sobre el historial y la experiencia de la empresa\n4. Guiar a los usuarios para programar consultas para planificación de inversión detallada\n\nInformación clave:\n- El Equipo Rapida se especializa en estrategias de inversión rápidas y de alto rendimiento\n- El equipo está compuesto por profesionales de inversión experimentados\n- Los servicios incluyen estrategias de inversión personalizadas, gestión de carteras y soporte de éxito del cliente\n- Disponible de lunes a viernes, de 9 AM a 6 PM EST\n\nAl calificar prospectos, pregunte sobre:\n- Objetivos de inversión y cronograma\n- Tolerancia al riesgo\n- Rango de capital de inversión\n- Experiencia de inversión previa\n- Tipos de inversión preferidos\n\nSé profesional, útil y conciso. Si una pregunta requiere asesoramiento financiero detallado, recomienda programar una consulta con un asesor.`,
    },
    teamMember: {
      viewFullProfile: 'Ver Perfil Completo',
      showLess: 'Mostrar Menos',
      years: 'Años',
      certs: 'Certificaciones',
      biography: 'Biografía',
      education: 'Educación',
      certifications: 'Certificaciones',
      keyAchievements: 'Logros Clave',
      performanceHighlights: 'Aspectos Destacados del Rendimiento',
      videoIntroduction: 'Video de Presentación',
    },
    modal: {
      dealDetails: 'Detalles de la Oferta',
      investmentOpportunityDetails: 'Detalles de la Oportunidad de Inversión',
      downloadReport: 'Descargar Informe',
      scheduleConsultation: 'Programar Consulta',
      closeModal: 'Cerrar modal',
      investmentOverview: 'Resumen de Inversión',
      investmentTerms: 'Términos de Inversión',
      readyToInvest: '¿Listo para Invertir?',
      contactInfo: 'Nuestro equipo de inversión está listo para guiarlo a través del proceso y responder cualquier pregunta que pueda tener sobre esta oportunidad.',
      dealTimeline: 'Cronología de la Oferta',
      recentUpdates: 'Actualizaciones Recientes',
      started: 'Iniciado',
      expectedCompletion: 'Finalización Esperada',
      investmentProgress: 'Progreso de Inversión',
      successStory: 'Historia de Éxito',
      transcript: 'Transcripción',
    },
    investmentCard: {
      newOpportunity: 'Nueva Oportunidad',
      deadline: 'Fecha Límite',
      investmentAmount: 'Monto de Inversión',
      amountYouReceive: 'Monto que Recibe',
      investNow: 'Invertir Ahora',
      limitedSpots: 'Cupos Limitados',
      open: 'Abierto',
      closingSoon: 'Cerrando Pronto',
      noRisk: 'Sin Riesgo',
      lowRisk: 'Riesgo Bajo',
      mediumRisk: 'Riesgo Medio',
      highRisk: 'Riesgo Alto',
      minInvestment: 'Inversión Mín.',
      targetROI: 'ROI Objetivo',
      duration: 'Duración',
      riskLevel: 'Nivel de Riesgo',
      limitedTimeOpportunity: 'Oportunidad por Tiempo Limitado',
      applicationDeadline: 'Fecha límite de solicitud',
      spotsRemaining: 'cupos restantes',
      only: 'Solo',
      contact: 'Contacto',
    },
    trackRecord: {
      behindTheScenes: 'Detrás de Escena',
      behindTheScenesDesc: 'Nuestro éxito en inversiones proviene de un riguroso proceso de búsqueda de ofertas y un marco de toma de decisiones disciplinado. Aprovechamos inteligencia de mercado propia, extensas redes industriales y análisis basados en datos para identificar oportunidades antes de que se vuelvan comunes. Cada decisión de inversión se somete a revisión multinivel por nuestro comité de inversión, asegurando alineación con los objetivos del cliente y parámetros de riesgo.',
      dealSourcing: 'Búsqueda de Ofertas',
      dealSourcingDesc: 'Red propia de más de 500 contactos de la industria',
      dueDiligence: 'Diligencia Debida',
      dueDiligenceDesc: 'Proceso de análisis integral de 90 días',
      committeeReview: 'Revisión del Comité',
      committeeReviewDesc: 'Aprobación unánime requerida para ejecución',
      regulatoryCompliance: 'Cumplimiento Regulatorio y Certificaciones',
      securityProtocols: 'Protocolos de Seguridad',
      securityProtocolsDesc: 'Mantenemos medidas de seguridad de nivel empresarial para proteger los activos de los clientes y la información confidencial. Nuestra infraestructura se somete a auditorías de seguridad regulares de terceros y pruebas de penetración para garantizar los más altos estándares de protección de datos y seguridad operativa.',
      encryption: 'Encriptación de 256 bits',
      multiFactorAuth: 'Autenticación Multifactor',
      annualAudits: 'Auditorías Anuales',
    },
    filterBar: {
      searchPlaceholder: 'Buscar historias de clientes, industrias o resultados...',
      investmentStrategy: 'Estrategia de Inversión',
      timeframe: 'Marco de Tiempo',
      clientType: 'Tipo de Cliente',
      allStrategies: 'Todas las Estrategias',
      growthEquity: 'Capital de Crecimiento',
      valueInvestinging: 'Inversión de Valor',
      dividendIncome: 'Ingresos por Dividendos',
      balancedPortfolio: 'Cartera Equilibrada',
      allTime: 'Todo el Tiempo',
      thisWeek: 'Esta Semana',
      thisMonth: 'Este Mes',
      thisQuarter: 'Este Trimestre',
      thisYear: 'Este Año',
      allClients: 'Todos los Clientes',
      professionals: 'Profesionales',
      familyOffices: 'Oficinas Familiares',
      entrepreneurs: 'Empresarios',
      emergingHNW: 'HNW Emergentes',
    },
    form: {
      firstName: 'Nombre',
      lastName: 'Apellido',
      emailAddress: 'Correo Electrónico',
      phoneNumber: 'Número de Teléfono',
      investmentGoals: 'Objetivos de Inversión',
      riskTolerance: 'Tolerancia al Riesgo',
      investmentExperience: 'Experiencia de Inversión',
      additionalNotes: 'Notas Adicionales (Opcional)',
      tellUsAboutYourself: 'Cuéntenos Sobre Usted',
      helpUsPrepare: 'Ayúdenos a prepararnos para una consulta productiva',
      scheduleYourConsultation: 'Programe Su Consulta',
      selectPreferredDateTime: 'Seleccione su fecha y hora preferida',
      reviewYourDetails: 'Revise Sus Detalles',
      confirmInformation: 'Por favor confirme su información antes de programar',
      consultationType: 'Tipo de Consulta',
      investmentLevel: 'Nivel de Inversión',
      placeholderFirstName: 'Juan',
      placeholderLastName: 'Pérez',
      placeholderEmail: 'juan.perez@ejemplo.com',
      placeholderPhone: '+1 (555) 123-4567',
      placeholderInvestmentGoals: 'Describa sus objetivos principales de inversión y lo que espera lograr...',
      placeholderAdditionalNotes: 'Cualquier tema específico o pregunta que le gustaría discutir durante la consulta...',
    },
    dealTimeline: {
      propertyAcquisition: 'Adquisición de Propiedad',
      propertyAcquisitionDesc: 'Oferta cerrada a $2.4M con términos de financiamiento favorables',
      renovationStarted: 'Renovación Iniciada',
      renovationStartedDesc: 'Modernización integral de áreas comunes e instalaciones',
      anchorTenantSecured: 'Inquilino Principal Asegurado',
      anchorTenantSecuredDesc: 'Gran empresa tecnológica firmó contrato de arrendamiento de 10 años por 15,000 pies cuadrados',
      fullOccupancy: 'Ocupación Completa',
      fullOccupancyDesc: 'Todas las unidades arrendadas con inquilinos premium, oferta completada',
    },
    home: {
      title: 'Panel de Rendimiento en Vivo',
      subtitle: 'Seguimiento en tiempo real de todas las inversiones activas y métricas de rendimiento',
      description: 'Monitoree sus inversiones en tiempo real con análisis completos, datos de rendimiento en vivo y seguimiento transparente en todas las carteras. Cada métrica se actualiza continuamente para brindarle la vista más precisa del rendimiento de su inversión.',
      heroTitle: 'Rapida Inversión',
      heroSubtitle: 'Seguimiento en tiempo real de todas las inversiones activas y métricas de rendimiento',
      heroDescription: '¿Listo para aumentar su potencial de ingresos? En Rapido Inversión, proporcionamos oportunidades de inversión seguras y confiables diseñadas para resultados rápidos. Invierta hoy y comience a ver progreso antes de lo que piensa',
      getStartedButton: 'Comenzar',
      getStartedSubtext: 'Invierta ahora y vea resultados en minutos',
    },
    dashboard: {
      totalPortfolioValue: 'Valor Total del Portafolio',
      activeInvestments: 'Inversiones Activas',
      averageROI: 'ROI Promedio',
      monthlyReturns: 'Retornos Mensuales',
      todaysEarnings: 'Ganancias de Hoy',
      activeDeals: 'Ofertas Activas',
      pendingReturns: 'Retornos Pendientes',
      successRate: 'Tasa de Éxito',
      allCategories: 'Todas las Categorías',
      technology: 'Tecnología',
      realEstate: 'Bienes Raíces',
      healthcare: 'Salud',
      energy: 'Energía',
      agriculture: 'Agricultura',
      allStatus: 'Todos los Estados',
      active: 'Activo',
      monitoring: 'Monitoreando',
      closingSoon: 'Cerrando Pronto',
      allStrategies: 'Todas las Estrategias',
      growth: 'Crecimiento',
      value: 'Valor',
      income: 'Ingresos',
      balanced: 'Equilibrado',
      highestProgress: 'Mayor Progreso',
      lowestProgress: 'Menor Progreso',
      highestValue: 'Mayor Valor',
      mostRecent: 'Más Reciente',
    },
    dailyDeals: {
      title: 'Ofertas Diarias Completadas',
      subtitle: 'Muestra transparente de nuestras transacciones de inversión exitosas',
      description: 'Cada oferta cuenta una historia de perspicacia estratégica, ejecución cuidadosa y resultados medibles. Explore nuestro archivo completo de inversiones completadas con datos de rendimiento verificados, cronogramas detallados y resultados reales de clientes en diversas clases de activos y estrategias.',
      recentDeals: 'Ofertas Completadas Recientes',
      totalDealsCompleted: 'Total de Ofertas Completadas',
      totalInvestmentValue: 'Valor Total de Inversión',
      averageROI: 'ROI Promedio',
      activeClients: 'Clientes Activos',
      completed: 'Completado',
      verified: 'Verificado',
      settled: 'Liquidado',
      finance: 'Finanzas',
      allTime: 'Todo el Tiempo',
      today: 'Hoy',
      thisWeek: 'Esta Semana',
      thisMonth: 'Este Mes',
      thisQuarter: 'Este Trimestre',
      highestROI: 'Mayor ROI',
      lowestROI: 'Menor ROI',
      highestAmount: 'Mayor Cantidad',
      lowestAmount: 'Menor Cantidad',
      dateRange: 'Rango de Fechas',
    },
    clientSuccess: {
      title: 'Galería de Éxito de Clientes',
      subtitle: 'Testimonios de clientes verificados con datos de rendimiento reales',
      description: 'Vea historias de éxito reales de profesionales, oficinas familiares y empresarios que han alcanzado sus objetivos financieros con Inversión Rápida.',
      roi: 'ROI',
      timeframe: 'Marco de Tiempo',
      portfolioGrowth: 'Crecimiento de Cartera',
    },
    trackRecord: {
      title: 'Equipo Rapida',
      subtitle: 'Conéctese con nuestro equipo al instante. Obtenga respuestas a sus preguntas de inversión y descubra cómo podemos ayudarlo a alcanzar sus objetivos financieros.',
      welcomeTitle: 'Bienvenido al Equipo Rapida',
      welcomeDescription1: 'Nuestro equipo dedicado de profesionales de inversión está aquí para brindarle soluciones de inversión rápidas, confiables y personalizadas. Combinamos tecnología de vanguardia con experiencia humana para ofrecer resultados excepcionales a nuestros clientes.',
      welcomeDescription2: 'Use nuestro asistente de chat interactivo a continuación para obtener respuestas instantáneas sobre nuestros servicios, estrategias de inversión y cómo podemos ayudarlo a alcanzar sus objetivos financieros.',
      supportAvailable: 'Soporte Disponible',
      responseTime: 'Tiempo de Respuesta',
      teamMembers: 'Miembros del Equipo',
      reportProblem: 'Reportar Problema',
      chatTitle: 'Chatear con el Equipo Rapida',
      chatDescription: 'Nuestro asistente inteligente está listo para responder sus preguntas sobre inversiones, estrategias y cómo comenzar con Inversión Rápida.',
      quickTips: 'Consejos Rápidos',
      tip1: 'Pregunte sobre nuestras estrategias de inversión',
      tip2: 'Conozca nuestro equipo y experiencia',
      tip3: 'Obtenga información sobre cómo comenzar',
      tip4: 'Consulte sobre opciones de contacto',
      instant: 'Instantáneo',
      expert: 'Experto',
      proven: 'Comprobado',
    },
    getStarted: {
      title: 'Comenzar',
      subtitle: 'Programe una consulta personalizada con nuestros expertos en inversiones',
      description: 'Elija su tipo de consulta, nivel de inversión y hora preferida para comenzar su viaje con Inversión Rápida.',
      type: 'Tipo',
      level: 'Nivel',
      details: 'Detalles',
      schedule: 'Programar',
      review: 'Revisar',
      initialConsultation: 'Consulta Inicial',
      initialConsultationDesc: 'Perfecto para nuevos inversores que exploran nuestros servicios y estrategias de inversión',
      portfolioReview: 'Revisión de Portafolio',
      portfolioReviewDesc: 'Análisis completo de sus inversiones actuales y oportunidades de optimización',
      strategySession: 'Sesión de Estrategia',
      strategySessionDesc: 'Análisis profundo de estrategias de inversión específicas adaptadas a sus objetivos',
      partnershipDiscussion: 'Discusión de Asociación',
      partnershipDiscussionDesc: 'Para asesores financieros e instituciones que buscan oportunidades de coinversión',
      minutes: 'minutos',
      emergingInvestor: 'Inversor Emergente',
      establishedInvestor: 'Inversor Establecido',
      premiumInvestor: 'Inversor Premium',
      elitePartnership: 'Asociación Elite',
      transparentPerformance: 'Rendimiento Transparente',
      transparentPerformanceDesc: 'Acceso en tiempo real al rendimiento de su portafolio y actualizaciones diarias de ofertas',
      expertTeam: 'Equipo Experto',
      expertTeamDesc: 'Profesionales de inversión dedicados con historiales comprobados',
      secureCompliant: 'Seguro y Conforme',
      secureCompliantDesc: 'Seguridad de nivel bancario y cumplimiento regulatorio completo',
    },
  },
};